import React, { useMemo } from 'react';
import {
  TableRow,
  TableCell,
  Typography,
  Stack,
  useTheme,
  IconButton
} from '@mui/material';
import { DateTime } from 'luxon';
import { useNavigate } from 'react-router-dom';
import { CustomIcon } from 'modules/components/layer00';
import { menuUtil } from 'modules/common';
import { StandardAreaInstallationMenu } from 'modules/components/layer19';

export type StandardAreaInstallationTableRowProps = {
  displayName: string;
  id: string;
  milestoneId: string;
  milestoneName: string;
  name: string;
  subAreaId: string;
  subAreaName: string;
  areaName: string;
  typeId: string;
  type: string;
};

export const FC = (props: StandardAreaInstallationTableRowProps) => {
  const navigate = useNavigate();

  const {
    anchorEl,
    handleClick,
    handleClose,
    open
  } = menuUtil.useBaseMenuState();


  return (
    <TableRow
      onClick={(e) => {
        e.stopPropagation();
        // navigate(`${props.id}`);
      }}
    >
      <TableCell
        variant='body'
      >
        {props.displayName}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.areaName}
      </TableCell>

      <TableCell
        variant='body'
      >
        {props.subAreaName}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.type}
      </TableCell>

      <TableCell
        variant='body'
      >
        {props.milestoneName === '' ? 'N/A' : props.milestoneName}
      </TableCell>
      <TableCell
        variant='body'
      >
        <IconButton
          onClick={(e) => handleClick(e)}
        >
          <CustomIcon.large.FC icon='MOREVERTICAL' />
        </IconButton>
        {open && (
          <StandardAreaInstallationMenu.FC
            open={open}
            anchorEl={anchorEl}
            handleClick={handleClick}
            handleClose={handleClose}
            id={props.id}
          />
        )}
      </TableCell>
    </TableRow>

  );
};
